export const ALL_RATINGS = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];

export const SUBHEADINGS = [
  "Is it noon yet?",
  // "But how is your urine?",
  "Skill issue",
  "Reading comprehension at an all time low",
  "It's so over",
  "We are so back",
  "See you at the movies!",
  "Support women",
  "Nicole Kidman AMC ad",
  "Slutty little glasses",
  "Have you ever touched a horse?",
  "Fork found in the kitchen",
  "🫙",
];

export const moviesData = [
  {
    title: "Conclave",
    usersWatched: 33,
    rating: 3.45,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/8/7/7/2/5/3/877253-conclave-0-230-0-345-crop.jpg?v=f9cbf50dec",
  },
  {
    title: "Avengers: Infinity War",
    usersWatched: 32,
    rating: 2.56,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/2/2/6/6/6/1/226661-avengers-infinity-war-0-230-0-345-crop.jpg?v=8b35f60c0c",
  },
  {
    title: "Oppenheimer",
    usersWatched: 32,
    rating: 3.58,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/7/8/4/3/2/8/784328-oppenheimer-0-230-0-345-crop.jpg?v=e3c6e7a32c",
  },
  {
    title: "Dune",
    usersWatched: 32,
    rating: 3.27,
    poster:
      "https://a.ltrbxd.com/resized/sm/upload/nx/8b/vs/gc/cDbNAY0KM84cxXhmj8f0dLWza3t-0-230-0-345-crop.jpg?v=49eed12751",
  },
  {
    title: "Barbie",
    usersWatched: 32,
    rating: 3.64,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/2/7/7/0/6/4/277064-barbie-0-230-0-345-crop.jpg?v=1b83dc7a71",
  },
  {
    title: "Past Lives",
    usersWatched: 31,
    rating: 4.13,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/5/9/1/0/5/3/591053-past-lives-0-230-0-345-crop.jpg?v=c600b7854e",
  },
  {
    title: "Spider-Man: Into the Spider-Verse",
    usersWatched: 32,
    rating: 4.05,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/2/5/1/9/4/3/251943-spider-man-into-the-spider-verse-0-230-0-345-crop.jpg?v=538fe0ada6",
  },
  {
    title: "Dune: Part Two",
    usersWatched: 32,
    rating: 4.02,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/6/1/7/4/4/3/617443-dune-part-two-0-230-0-345-crop.jpg?v=cc533700f8",
  },
  {
    title: "Sinners",
    usersWatched: 32,
    rating: 3.97,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/1/1/1/6/6/0/0/1116600-sinners-2025-0-230-0-345-crop.jpg?v=5996b7d555",
  },
  {
    title: "Parasite",
    usersWatched: 29,
    rating: 3.95,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/4/2/6/4/0/6/426406-parasite-0-230-0-345-crop.jpg?v=8f5653f710",
  },
  {
    title: "Lady Bird",
    usersWatched: 28,
    rating: 3.95,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/3/2/6/2/7/9/326279-lady-bird-0-230-0-345-crop.jpg?v=754ff28eb4",
  },
  {
    title: "Anora",
    usersWatched: 32,
    rating: 3.86,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/9/5/9/5/4/0/959540-anora-0-230-0-345-crop.jpg?v=6f92877033",
  },
  {
    title: "Killers of the Flower Moon",
    usersWatched: 33,
    rating: 3.85,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/3/9/8/0/0/9/398009-killers-of-the-flower-moon-0-230-0-345-crop.jpg?v=49b577149d",
  },
  {
    title: "Challengers",
    usersWatched: 31,
    rating: 3.84,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/8/4/2/3/0/1/842301-challengers-0-230-0-345-crop.jpg?v=a7cd63cbef",
  },
  {
    title: "Mad Max: Fury Road",
    usersWatched: 32,
    rating: 3.77,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/6/2/7/8/0/62780-mad-max-fury-road-0-230-0-345-crop.jpg?v=37c5424b1f",
  },
  {
    title: "The Brutalist",
    usersWatched: 32,
    rating: 2.97,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/4/7/8/4/2/8/478428-the-brutalist-0-230-0-345-crop.jpg?v=2f8cae2ea5",
  },
  {
    title: "Everything Everywhere All at Once",
    usersWatched: 31,
    rating: 3.74,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/4/7/4/4/7/4/474474-everything-everywhere-all-at-once-0-230-0-345-crop.jpg?v=281f1a041e",
  },
  {
    title: "Top Gun: Maverick",
    usersWatched: 31,
    rating: 3.52,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/2/9/3/4/6/5/293465-top-gun-maverick-0-230-0-345-crop.jpg?v=9f8af0f61b",
  },
  {
    title: "Mission: Impossible – Fallout",
    usersWatched: 31,
    rating: 3.37,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/2/8/3/2/7/3/283273-mission-impossible-fallout-0-230-0-345-crop.jpg?v=04024ef596",
  },
  {
    title: "Civil War",
    usersWatched: 31,
    rating: 3.35,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/8/3/4/6/5/6/834656-civil-war-0-230-0-345-crop.jpg?v=aefec33dbe",
  },
  {
    title: "Black Bag",
    usersWatched: 31,
    rating: 3.34,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/1/1/1/6/7/5/5/1116755-black-bag-2025-0-230-0-345-crop.jpg?v=7dbc1baf6f",
  },
  {
    title: "The Holdovers",
    usersWatched: 31,
    rating: 3.34,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/7/5/5/5/6/4/755564-the-holdovers-0-230-0-345-crop.jpg?v=99bbdd8955",
  },
  {
    title: "The Big Lebowski",
    usersWatched: 31,
    rating: 3.32,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/5/1/9/3/5/51935-the-big-lebowski-0-230-0-345-crop.jpg?v=5cd64defcf",
  },
  {
    title: "Mission: Impossible",
    usersWatched: 31,
    rating: 2.89,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/5/1/2/0/6/51206-mission-impossible-0-230-0-345-crop.jpg?v=7b7690e145",
  },
  {
    title: "The Matrix",
    usersWatched: 31,
    rating: 3.48,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/5/1/5/1/8/51518-the-matrix-0-230-0-345-crop.jpg?v=fc7c366afe",
  },
  {
    title: "Spider-Man: Across the Spider-Verse",
    usersWatched: 31,
    rating: 3.65,
    poster:
      "https://a.ltrbxd.com/resized/film-poster/4/9/7/6/3/1/497631-spider-man-across-the-spider-verse-0-230-0-345-crop.jpg?v=f2acbf1b8a",
  },
];
